import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AgencyUserRoutes = defineRoute({
    home: {
        route: {
            path: "/agency-user",
            component: () => loadView(import("./AgencyUserHome.vue")),
        },
    },
    detail: {
        route: {
            path: "/agency-user/:id",
            component: () => loadView(import("./AgencyUserDetail.vue")),
        },
        build(id: string) {
            return `/agency-user/${id}`;
        },
    },
});
